function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';
import NavItem from './NavItem';
import { Grid, Row, Col } from '../Layout';
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light']),
  fullWidth: PropTypes.bool,
  contentComponent: PropTypes.func,
  location: PropTypes.object
};
var defaultProps = {
  theme: 'dark'
};

var Navigation = /*#__PURE__*/function (_Component) {
  _inherits(Navigation, _Component);

  var _super = _createSuper(Navigation);

  function Navigation() {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function (info) {
      _this.activeIndex = info.index;

      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "buildNewListChild", function (child, index) {
      var activeRoute = _this.state.activeRoute;
      var key = "list-".concat(index);
      var navItemChildren = child.props.children;

      if (navItemChildren) {
        var navItemChildrensChildren = navItemChildren.props.children;

        if (navItemChildrensChildren) {
          navItemChildrensChildren.forEach(function (childSubNav) {
            if (childSubNav.props.href === activeRoute) {
              _this.activeIndex = index;
            } else if (Array.isArray(childSubNav.props.children)) {
              childSubNav.props.children.forEach(function (childSubNavLink) {
                if (childSubNavLink.props.href === activeRoute) {
                  _this.activeIndex = index;
                }
              });
            }
          });
        }
      }

      return /*#__PURE__*/React.createElement("li", {
        className: "display-inlineblock marginleft-lg marginright-lg",
        role: "none"
      }, /*#__PURE__*/React.createElement(NavItem, _extends({}, child.props, {
        key: key,
        id: key,
        index: index,
        active: index === _this.activeIndex,
        onItemClick: _this.handleItemSelected
      })));
    });

    _this.activeIndex = null;
    _this.state = {
      activeRoute: ''
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          theme = _this$props.theme,
          fullWidth = _this$props.fullWidth,
          contentComponent = _this$props.contentComponent,
          location = _this$props.location;
      var globalProps = getValidElementProps('global', this.props);
      var newChildren = React.Children.map(children, function (child, index) {
        if (location) {
          _this2.activeIndex = null;
        }

        return _this2.buildNewListChild(child, index);
      });
      var themeClass = "nav-skin--".concat(theme);
      var ntClass = classnames('nav', themeClass, className);
      return /*#__PURE__*/React.createElement("nav", _extends({
        className: ntClass
      }, globalProps), /*#__PURE__*/React.createElement(Grid, {
        fluid: fullWidth
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("ul", {
        role: "menubar",
        className: "menubar list width-100p"
      }, newChildren, contentComponent && contentComponent())))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.location && nextProps.location.pathname) {
        return {
          activeRoute: nextProps.location.pathname
        };
      }

      return null;
    }
  }]);

  return Navigation;
}(Component);

Navigation.propTypes = propTypes;
Navigation.defaultProps = defaultProps;
Navigation.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleItemSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "info",
      "type": null
    }],
    "returns": null
  }, {
    "name": "buildNewListChild",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Navigation",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "fullWidth": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "contentComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "location": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Navigation;